import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'starpipe',
  standalone: true
})
export class StarArrayPipe implements PipeTransform {
  transform(totalAverageOutOf5: number, argument: string, isArray: boolean = false, totalStar: number = 5): any {
    if (isNaN(totalAverageOutOf5) || totalAverageOutOf5 == null) {
      return argument === 'totalRating' ? 0 : 0;
    }
    totalAverageOutOf5 = Math.max(0, Math.min(totalAverageOutOf5, totalStar));
    const roundedRating = Math.round(totalAverageOutOf5 * 2) / 2;
    const fullStar = Math.floor(roundedRating);
    const hasHalfStar = roundedRating % 1 !== 0 ? 1 : 0;
    const noStar = totalStar - (fullStar + hasHalfStar);
    if (argument === 'totalRating') {
      return roundedRating.toFixed(1);
    }
    if (argument === 'fullStar') {
      return isArray ? Array(fullStar).fill(0) : fullStar;
    }
    if (argument === 'halfStar') {
      return isArray ? Array(hasHalfStar).fill(0) : hasHalfStar;
    }
    if (argument === 'noStar') {
      return isArray ? Array(noStar).fill(0) : noStar;
    }
    return 0;
  }
}